import styled from 'styled-components';
import { Grid } from 'ui-toolkit';

export const CenterMessage = styled(Grid)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  justify-items: center;
  align-content: center;
`;
